/* eslint-disable import/prefer-default-export */
import { all, takeLatest, call, put } from "redux-saga/effects";
import firebase from "firebase/compat/app";
import API, { responseParser } from "../../services/api";
import {
  AUTO_LOGIN,
  GET_DEVICES,
  SET_DEVICES,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  EDIT_USER,
  SET_USER_INFO,
  EDIT_DEVICE,
  SET_DEVICE_INFO,
  COLD_RESET,
  FACTORY_RESET,
  REGISTER_DEVICE,
  UPDATE_FIRMWARE,
  GET_WEATHER,
  SET_WEATHER,
  SEND_MESSAGE,
} from "./types";

import "firebase/compat/auth";
import "firebase/compat/messaging";

function* getUserInfo(payload) {
  const response = yield call(api.autoAuthenticate);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_DEVICES, payload: result.controllers });
    yield put({ type: LOGIN_SUCCESS, payload: result.user });
  } else {
    try {
      firebase.auth().signOut();
      const messaging = firebase.messaging();
      messaging.deleteToken();
    } catch (err) {
      console.error(err);
    } finally {
      window.location.href = "/web/login";
      yield put({ type: LOGIN_ERROR });
    }
  }
}

function* autoLogin({ payload }) {
  if (payload.search) {
    const queryParams = new URLSearchParams(payload.search);
    const redirectUrl = queryParams.get("redirect_uri");
    const transferOwnership = queryParams.get("transfer-ownership");
    const state = queryParams.get("state");
    if (state && redirectUrl) {
      const code = payload.user.uid;
      window.location.replace(
        `${redirectUrl}?code=${code}&state=${state}&response_type=code`
      );
    } else if (transferOwnership) {
      console.log("transferOwnership", transferOwnership);
      yield call(getUserInfo, payload);
      const response = yield call(api.acceptOwnershipInvite, {
        id: transferOwnership,
      });
      const result = responseParser(
        response,
        "Error while accepting the invite",
        null,
        true,
        true
      );
      if (result) {
        window.location.href = "/web";
      }
    }
  } else {
    yield call(getUserInfo, payload);
  }
}

function* getDevices() {
  const response = yield call(api.getAllDevices);
  const result = responseParser(response);
  if (Array.isArray(result) && result.length) {
    const selectedDevice = result.find((item) => item.selected);
    if (!selectedDevice) {
      yield call(api.selectDevice, result[0]);
    }
    yield put({ type: SET_DEVICES, payload: result });
  }
}

function* editUser({ payload }) {
  const response = yield call(api.editUserInfo, payload);
  const result = responseParser(response, "Error", null, true, true);
  if (result) {
    yield put({ type: SET_USER_INFO, payload: result });
  } else {
    yield put({ type: SET_USER_INFO });
  }
}

function* editDevice({ payload }) {
  const response = yield call(api.editDeviceInfo, payload);
  const result = responseParser(response, "Error", null, true, true);
  if (result) {
    yield put({ type: SET_DEVICE_INFO, payload: result });
  } else {
    yield put({ type: SET_DEVICE_INFO });
  }
}

function* coldReset({ payload }) {
  const response = yield call(api.coldResetController, payload.device);
  const result = responseParser(response, "Error");
  if (result) {
    window.location.reload();
  }
}

function* factoryReset({ payload }) {
  const response = yield call(api.factoryResetController, payload.device);
  const result = responseParser(response, "Error");
  if (result) {
    window.location.reload();
  }
}

function* registerDevice({ payload }) {
  yield call(api.registerDevice, payload);
}

function* updateFirmware({ payload }) {
  const response = yield call(api.updateFirmware, payload);
  responseParser(response, "Error", "", true, true);
}

function* getWeather({ payload }) {
  const response = yield call(api.getWeather, payload);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_WEATHER, payload: result });
  }
}

function* sendMessage({ payload }) {
  const response = yield call(api.sendMqttMessage, payload);
  responseParser(response, "Error", "", true, true);
}

const api = API.create();
export function* combinedSagas() {
  yield all([
    yield takeLatest(AUTO_LOGIN, autoLogin),
    yield takeLatest(GET_DEVICES, getDevices),
    yield takeLatest(EDIT_USER, editUser),
    yield takeLatest(EDIT_DEVICE, editDevice),
    yield takeLatest(COLD_RESET, coldReset),
    yield takeLatest(FACTORY_RESET, factoryReset),
    yield takeLatest(REGISTER_DEVICE, registerDevice),
    yield takeLatest(UPDATE_FIRMWARE, updateFirmware),
    yield takeLatest(GET_WEATHER, getWeather),
    yield takeLatest(SEND_MESSAGE, sendMessage),
  ]);
}
